import { t } from "./to-integer-or-infinity.js";
var r = RangeError,
  e = function e(_e) {
    var n = t(_e);
    if (n < 0) throw r("The argument can't be less than 0");
    return n;
  };
export { e as t };